import { History } from '@client/components/_ui/display/History';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/risk/register/details/$id/history')({
    component: () => {
        const { id } = Route.useParams();
        return <History idValue={id} idPropertyName="riskId" />;
    },
});
